module.exports = __webpack_public_path__ + "static/media/NOPABChE Logo.57a9b0ec.png";